import { api, jsonToFormData } from "lib";
import apiFormData from "lib/apiFormData";


export const getWarningLetterRequestPaging = async (params = {}) => {
  return await api.post(
    "/v1/warningLetterRequest/getWarningLetterRequestPaging",
    params
  );
};


export const getWarningLetterRequestById = async (params = {}) => {
  return await api.post(
    "/v1/warningLetterRequest/getWarningLetterRequest",
    params
  );
};


export const createWarningLetterRequest = async (params = {}) => {
  return await api.post(
    "/v1/warningLetterRequest/createWarningLetterRequest",
    jsonToFormData(params)
  );
};


export const updateWarningLetterRequest = async (params) => {
  return await apiFormData.post(
    "/v1/warningLetterRequest/updateWarningLetterRequest",
    params
  );
};


export const manageWarningLetterRequestStatus = async (params = {}) => {
  return await api.post(
    "/v1/warningLetterRequest/manageWarningLetterRequestStatus",
    params
  );
};

export async function previewWarningLetterPdf(params) {
  const { companyId, lang, ...body } = params;
  return await api.post(
    `/v1/warningLetterRequest/previewPdf?companyId=${companyId}`,
    body,
    { responseType: "blob" }
  );
}